import React from 'react'
import { Helmet } from 'react-helmet-async'
import Landing from '../../Esg/Landing'
import { FaAngleRight, FaArrowRight } from 'react-icons/fa6'
import EsgCard from '../../Esg/EsgCard'
import CTO from '../../Esg/CTO'
const ESGTRAININ = [
    {
        title: "FOR CORPORATES",
        data: [
            {
                "title": "ESG 360°: Awareness to Action",
                "image": "/assets/images/esg-training/est-t-corporate-1.png",
                "description": "A comprehensive company-wide orientation that familiarizes all employees with ESG risks, sustainability impacts, and their role in embedding ESG into daily operations. This module ensures everyone understands how small actions contribute to larger organizational ESG goals.",
                "audience": ["All employees"]
            },
            {
                "title": "Boardroom to Bottom Line: ESG for Leaders",
                "image": "/assets/images/esg-training/est-t-corporate-2.png",
                "description": "Tailored for executives and decision-makers, this program covers governance, ESG disclosures, materiality assessments, and investor expectations. Leaders learn how to integrate ESG into strategic decisions and drive measurable business impact.",
                "audience": ["CXOs", "Directors", "ESG Heads"]
            },
            {
                "title": "Green Chain: Supplier & Vendor Capacity Building",
                "image": "/assets/images/esg-training/est-t-corporate-3.png",
                "description": "A comprehensive company-wide orientation designed to empower your supply chain. This training helps vendors, logistics partners, and contract manufacturers adopt ESG practices, conduct basic audits, and report effectively. Strengthen sustainability throughout your procurement ecosystem.",
                "audience": ["Vendors", "Logistics partners", "Contract manufacturers"]
            },
            {
                "title": "From Data to Disclosure: ESG Reporting",
                "image": "/assets/images/esg-training/est-t-corporate-4.png",
                "description": "Hands-on training for ESG, finance, and compliance teams to work with real-world ESG metrics. Learn to leverage frameworks like BRSR, CDP, GRI, and internal KPIs for accurate reporting, monitoring, and performance improvement.",
                "audience": ["ESG", "Finance", "Compliance Teams"]
            }
        ]
    },
    {
        title: "FOR ACADEMIA",
        data: [
            {
                "title": "ESG Curriculum Integration",
                "image": "/assets/images/esg-training/esg-t-acadmia-1.png",
                "description": "Embed ESG frameworks like GRI, BRSR, and SASB across disciplines—engineering, finance, law, and social sciences. Equip students with foundational knowledge in sustainability, materiality, and value chain risk.",
                "audience": ["Faculty", "Curriculum Designers"]
            },
            {
                "title": "Applied Sustainability Projects",
                "image": "/assets/images/esg-training/esg-t-acadmia-2.png",
                "description": "Facilitate hands-on ESG projects, including carbon audits, stakeholder assessments, and water stress analysis, leveraging ESG accounting tools and disclosure metrics.",
                "audience": ["Student Project Teams", "Academic Mentors"]
            },
            {
                "title": "Research & Innovation Collaboration",
                "image": "/assets/images/esg-training/esg-t-acadmia-3.png",
                "description": "Partner on cutting-edge studies around climate risk, just transition, scope 3 emissions, ESG-tech, and net-zero strategies. Align research initiatives with SBTi, TCFD, and UN SDGs for global impact.",
                "audience": ["Scholars"]
            },
            {
                "title": "Sustainable Campus Operations",
                "image": "/assets/images/esg-training/esg-t-acadmia-4.png",
                "description": "Implement ESG-aligned solutions on campus: energy efficiency, water reuse, sustainable procurement, and operational sustainability, guided by GHG Protocol, ISO 14001, and ESG KPIs.",
                "audience": ["Campus Administrators", "Facilities Teams"]
            },
            {
                "title": "Industry-Readiness Pathways",
                "image": "/assets/images/esg-training/esg-t-acadmia-5.png",
                "description": "Prepare students for green careers with practical training on ESG disclosures, climate risk management, sustainability strategies, scope emissions, and ESG due diligence.",
                "audience": ["Final-Year Students", "Placement Cells"]
            },
            {
                "title": "Student Engagement on ESG",
                "image": "/assets/images/esg-training/esg-t-acadmia-6.png",
                "description": "Conduct interactive workshops on carbon accounting, GHG inventories, SDG alignment, ESG reporting, and data visualization to enhance ESG literacy among students.",
                "audience": ["University Students", "Sustainability Clubs"]
            },
            {
                "title": "Public Awareness Initiatives",
                "image": "/assets/images/esg-training/esg-t-acadmia-7.png",
                "description": "Organize ESG talks, climate finance workshops, and awareness programs based on CDP, IPCC reports, and national ESG mandates to foster a sustainability-conscious community.",
                "audience": ["Educators", "Outreach Units"]
            }
        ]
    }
]


const FEATURES = [
    {
        "title": "Built for Impact | Designed for Delivery",
        "image": "/assets/images/esg-training/esg-t-w-choose-n-1.png",
        "description": "Our programs are crafted to create tangible ESG outcomes for organizations, campuses, and communities."
    },
    {
        "title": "Industry-Aligned | Fast-Track Formats",
        "image": "/assets/images/esg-training/esg-t-w-choose-n-2.png",
        "description": "From 2-hour workshops to 2-week intensive programs, our training aligns with sector-specific ESG needs and global standards."
    },
    {
        "title": "Certification-Ready | Custom by Sector & Function",
        "image": "/assets/images/esg-training/esg-t-w-choose-n-3.png",
        "description": "Get recognized ESG skills with programs tailored for corporate functions, academic disciplines, and supply chains."
    },
    {
        "title": "Actionable Skills | Toolkits & Dashboards",
        "image": "/assets/images/esg-training/esg-t-w-choose-n-4.png",
        "description": "Learn practical skills with ready-to-use templates, reporting dashboards, and hands-on toolkits to implement ESG immediately."
    },
    {
        "title": "Multi-Stakeholder | Comprehensive Reach",
        "image": "/assets/images/esg-training/esg-t-w-choose-n-5.png",
        "description": "Programs designed for corporates, universities, public institutions, and community initiatives to foster ESG adoption at all levels."
    }
]


const WHOITSFOR = [
    {
        "id": "01",
        "title": "Business Leaders &\n Executives"
    },
    {
        "id": "02",
        "title": "Academic Institutions,\n Faculty & Students"
    },
    {
        "id": "03",
        "title": "ESG / CSR\n Teams"
    },
    {
        "id": "04",
        "title": "Vendors & Supply Chain\n Partners"
    },
    {
        "id": "05",
        "title": "Impact Incubators\n & NGOs"
    },
    {
        "id": "06",
        "title": "Public Sector\n Units"
    }
]




function ESGTrainingView() {
    return (
        <>
            <Helmet>
                <title>ESG Training Programs for Corporate Teams | Nirantara</title>
                <meta name="description" content="Nirantara's ESG training programs equip corporate teams, leaders, and academic institutions with practical skills in ESG strategy, BRSR reporting, carbon accounting, sustainability frameworks, and responsible business practices." />
                <meta name="keywords" content="ESG Training Programs for Corporate Teams, sustainability consulting for ESG compliance, ESG strategy development services, corporate sustainability consulting services" />
                <link rel="canonical" href="https://nirantara.solutions/esg-trainings" />
            </Helmet>
      <h1 className="sr-only">ESG Training Programs for Corporate Teams</h1>
            <Landing
                image={"/esg-training.jpg"}
                text={"ESG \n Training"}
                button={{
                    text: "Start Your ESG Journey", action: () => {
                        window.location.href = "/contact-us"
                    },
                    icon: <FaAngleRight />
                }}
            />
            <section className="w-full py-16 bg-gray-50 md:py-24" style={{ paddingLeft: '8%', paddingRight: '8%' }}>
                <div className="max-w-[1400px] mx-auto">
                    <h2 className="mb-8 text-3xl font-semibold text-black md:text-4xl lg:text-5xl" style={{ fontFamily: 'Poppins', fontWeight: 600, lineHeight: '1.3' }}>
                        ESG Learning Suite - Skilling for a Sustainable Future
                    </h2>
                    <div className="space-y-6 text-gray-700 montserrat">
                        <p className="text-base !leading-8 sm:!leading-10 md:!leading-10  tracking-wide md:text-lg">
                            Empower your teams with practical ESG training that drives real-world impact. Our ESG Learning Suite offers fast, high-impact programs for organizations and academic institutions, helping them integrate environmental, social, and governance principles seamlessly into operations. From boardroom strategy sessions to classroom workshops, we build the mindset and skills needed for a sustainable tomorrow.
                        </p>
                    </div>
                </div>
            </section>
            {ESGTRAININ && ESGTRAININ?.map((esgTraining, index) => (
                <div
                    className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#EDEDED]">
                    <h5 className='font-bold text-left text-black text-[2.2rem] sm:pt-3 w-full'>{esgTraining.title}</h5>
                    <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-16">
                        {esgTraining.data && esgTraining.data.length > 0 && esgTraining.data.map((item, index) => {
                            const { title, subtitle, description, cta, image, audience } = item;
                            return (
                                <EsgCard
                                    title={title.toUpperCase()}
                                    subtitle={subtitle}
                                    description={description}
                                    cta={cta}
                                    Icon={image}
                                    key={index}
                                    audience={audience}
                                />
                            )
                        })}
                    </div>
                </div>
            )
            )}
            <section className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#FFFFFF]">
                <h2 className="text-center text-3xl sm:text-4xl font-extrabold text-[#1A1A1A] my-4 sm:my-10">
                    Why Choose Nirantara ESG Programs?
                </h2>

                <div className="grid pr-0 md:grid-cols-2 sm:grid-cols-1">
                    {FEATURES?.map((item, i) => (
                        <div
                            key={i}
                            className={`flex items-start gap-4 py-10 border-b-2 border-gray-300 ${i < 4 ? 'md:border-b-2' : 'md:border-b-0'
                                } ${i === FEATURES.length - 1 ? '!border-b-0' : ''}`}
                        >

                            <div className={`p-1 rounded-lg ${item.bgColor}`}>
                                <img src={item.image} alt={item.title} style={{ width: item?.width }} />
                            </div>
                            <div>
                                <h3 className="mb-1 text-xl font-semibold text-gray-800">
                                    {item.title}
                                </h3>
                                <p className="text-sm leading-relaxed text-gray-600">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <section className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#EB7E0E]">
                <h2 className="text-center text-3xl sm:text-4xl font-extrabold text-[#1A1A1A] my-4 sm:my-10">
                    Who It’s For
                </h2>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
                    {WHOITSFOR?.map((item, i) => (
                        <div
                            key={i}
                            className={`py-10 bg-[#FFF] p-10 rounded-[12px] flex items-center gap-6`}
                        >
                            <div>
                                <p className='text-2xl md:text-3xl font-bold text-[#1C486B]'>{item.id}</p>
                                <h3
                                    className="mb-1 text-xl lg:text-2xl md:text-2xl font-semibold text-[#1C486B] whitespace-pre-line tracking-wide"
                                    style={{ wordSpacing: "4px" }}
                                >
                                    {item.title}
                                </h3>

                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <CTO />


        </>
    )
}

export default ESGTrainingView